<template>
  <div class="app">
    <div class="payment-page">
      <div class="header">
        <div class="payment-head">{{$t('paymentreview')}}</div>
        <router-link to="/buy-gold">
         <img src="../assets/images/cross-gray.svg" />
         </router-link>
      </div>

      <div class="container container-payment">
        <Timer timing="240" :text="$t('time')" />
        <div class="mid-panel">
          <div class="gold-amount gold-pay">
            <div class="amount-img">
              <img src="../assets/images/gold-text.png" />
              <p>{{$t('boughtgold')}}</p>
              <div class="gold-no">
                ₹{{this.$route.params.buy_price}}
                <span>={{this.$route.params.gold_amount}}{{$t('gram')}}</span>
              </div>
            </div>
          </div>
          <div class="amount-details">
            <div class="offer">
              <div class="details-wallet" v-if="walletDiscount">
                <input type="checkbox" checked v-model="isChecked" />

                {{$t('wallet')}} {{$t('discount')}}
                <div class="gold-rs">
                  <img src="../assets/images/mach.svg" />
                  {{roundOff(walletDiscount, 2)}}
                </div>
              </div>
            </div>
            <div class="offer-price">
              <div class="details">
                {{$t('paywithdiscount')}}
                <div
                  class="price"
                >₹{{roundOff(this.$route.params.buy_price-(isChecked ? walletDiscount : 0),2)}}</div>
              </div>
              <div class="details">
                {{$t('processingcharge')}}
                <div class="price">
                  <img src="../assets/images/wallet.svg" />
                  {{user.purchase_offer.processing_fee}}
                </div>
              </div>
            </div>
            <div class="pay">
              <div class="details">{{$t('pay')}}</div>
              <div
                class="pay-price"
              >=₹{{roundOff(this.$route.params.buy_price-(isChecked ? walletDiscount : 0),2)}}</div>
            </div>

            <button
              class="button"
              @click="purchaseGold"
            >{{$t('buy')}} ₹{{roundOff(this.$route.params.buy_price-(isChecked ? walletDiscount : 0),2)}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getDiscount, roundOff } from "../utils/helper";
import Timer from "../components/Timer";
import { SessionHelper } from "../utils/session"
export default {
  components: {
    Timer
  },

  data() {
    return {
      loading: false,
      walletDiscount: 0,
      isChecked: false
    };
  },

  computed: {
    ...mapGetters(["user"])
  },

  methods: {
    roundOff,
    calculateWalletDiscount() {
      const { purchase_offer, user_purse_details } = this.user;
      if (!Number(user_purse_details.wallet)) {
        this.walletDiscount = 0;
        return;
      }
      const walletOfferAmount =
        (this.$route.params.buy_price * purchase_offer.wallet_percentage) / 100;
      if (walletOfferAmount > user_purse_details.wallet) {
        this.walletDiscount = user_purse_details.wallet;
        return;
      }
      if (walletOfferAmount > purchase_offer.max_wallet) {
        this.walletDiscount = purchase_offer.max_wallet;
        return;
      }
      this.walletDiscount = walletOfferAmount;
      const total_amount = this.$route.params.buy_price - this.walletDiscount;
      if (total_amount < 1) {
        this.walletDiscount = 0;
      }
    },

    purchaseGold() {
      this.loading = !this.loading;
      SessionHelper.setCookie("isRedirectToPayment", true)
      const wallet_discount = this.isChecked
        ? roundOff(this.walletDiscount, 2)
        : 0;
      window.location.href = `https://goldbe.services-money91.com/buy_management/buy_confirmation?tx_id=${String(
        this.$route.params.tx_id
      )}&wallet=${wallet_discount}`;
    },

    yourCallBackFunction() {
      this.$router.push("/");
    }
  },
  mounted() {
    document.addEventListener("backbutton", this.yourCallBackFunction, false);
    this.calculateWalletDiscount();
  },
  beforeDestroy() {
    document.removeEventListener("backbutton", this.yourCallBackFunction);
  }
};
</script>